export default __webpack_public_path__ + "static/media/Marathi_bf_2.acf20c16.mp3";